import { createSelector } from "reselect";

const pageSelect = (state) => state.page;

export const selectPageData = createSelector(
  [pageSelect],
  (page) => page.pageData.appraisalDetail
);

export const selectInsurance = createSelector(
  [pageSelect],
  (page) => page.pageData.selectedInsuranceCompany
);

export const selectPageChats = createSelector(
  [pageSelect],
  (page) => page.pageData.appraisalChats
);

export const selectPageListing = createSelector(
  [pageSelect],
  (page) => page.pageData
);

export const isSidebarVisible = createSelector(
  [pageSelect],
  (page) => page.showSideBar
);

export const selectLoading = createSelector(
  [pageSelect],
  (page) => page.loading
);

export const selectActionChatId = createSelector(
  [pageSelect],
  (page) => page.actionChatID
);

export const selectIsNewAppraisal = createSelector(
  [pageSelect],
  (page) => page.isNewAppraisal
);

export const selectShopProfile = createSelector(
  [pageSelect],
  (page) => page.shopProfile
);

export const selectPageOverdue = createSelector(
  [pageSelect],
  (page) => page.pageData.overdueData
);
